const AUTH_KEY = 'agus-bsn@auth';
const LAST_ZONE_KEY = 'agus-bs-uri';

const tryParse = (json) => {
	try {
		return JSON.parse(json);
	} catch {
		return null;
	}
};

export const getLocalAuth = () => {
	try {
		const auth = sessionStorage.getItem(AUTH_KEY);
		return auth ? tryParse(auth) : null;
	} catch {
		console.error('Something went wrong.');
		return null;
	}
};

export const setLocalAuth = (auth) => {
	try {
		sessionStorage.setItem(AUTH_KEY, JSON.stringify(auth));
	} catch {
		console.error('Something went wrong.');
	}
};

export const updatedOpenData = (open) => {
	try {
		const auth = sessionStorage.getItem(AUTH_KEY);
		if (auth) {
			const authObject = tryParse(auth);
			if (authObject && authObject.data) {
				authObject.data.open = open;
				sessionStorage.setItem(AUTH_KEY, JSON.stringify(authObject));
			}
		} else {
			console.error('Something went wrong.');
		}
	} catch {
		console.error('Something went wrong.');
	}
};

export const updatedAuth = (data) => {
	try {
		const auth = sessionStorage.getItem(AUTH_KEY);
		if (auth) {
			const authObject = tryParse(auth);
			if (authObject && authObject.data) {
				authObject.data = { ...authObject.data, ...data };
				sessionStorage.setItem(AUTH_KEY, JSON.stringify(authObject));
			}
		} else {
			console.error('Something went wrong.');
		}
	} catch {
		console.error('Something went wrong.');
	}
};

export const clearLocalAuth = () => {
	try {
		sessionStorage.removeItem(AUTH_KEY);
	} catch {
		console.error('Something went wrong.');
	}
};

export const setLastZone = (route) => {
	try {
		sessionStorage.setItem(LAST_ZONE_KEY, route);
	} catch {
		console.error('Something went wrong.');
	}
};

export const getLastZone = () => {
	try {
		const storedRoute = sessionStorage.getItem(LAST_ZONE_KEY);
		return storedRoute;
	} catch {
		console.error('Something went wrong.');
		return null;
	}
};

export const clearLastZone = () => {
	try {
		sessionStorage.removeItem(LAST_ZONE_KEY);
	} catch {
		console.error('Something went wrong.');
	}
};
